import { API } from "aws-amplify";
import moment from "moment-timezone";
import dayjsTZ from "../../../../utils/dayjs";

export const preparePrePayments = (timeframe, employeeId, prepayments) => {
	let temp;

	if (prepayments.length > 0) {
		temp = prepayments.find(
			(el) =>
				dayjsTZ(el?.period[0]).format("DD/MM/YYYY") ===
					dayjsTZ(timeframe?.start).format("DD/MM/YYYY") && el?.employeeId === employeeId
		);
	}

	return temp || {};
};
